// extracted by mini-css-extract-plugin
export default {"container":"history_container__V3ppL","section":"history_section__LfAKX"};